(function () {
  function initPromoBanners() {
    document.querySelectorAll('[data-promo-banner]').forEach(function (banner) {
      if (banner.dataset.promoBannerInit === 'true') return;
      banner.dataset.promoBannerInit = 'true';

      var header = banner.querySelector('[data-promo-banner-toggle]');
      var content = banner.querySelector('[data-promo-banner-content]');
      var chevron = banner.querySelector('[data-promo-banner-chevron]');

      if (!header || !content) return;

      header.addEventListener('click', function () {
        var isOpen = banner.getAttribute('aria-expanded') === 'true';
        banner.setAttribute('aria-expanded', String(!isOpen));
        content.hidden = isOpen;
        header.setAttribute('aria-expanded', String(!isOpen));

        if (chevron) {
          chevron.style.transform = isOpen ? '' : 'rotate(-90deg)';
        }
      });

      var copyBtn = banner.querySelector('[data-promo-copy-btn]');
      if (copyBtn) {
        var labelEl = copyBtn.querySelector('[data-promo-copy-label]');
        var originalLabel = labelEl ? labelEl.textContent : '';
        var copiedLabel = copyBtn.getAttribute('data-copied-label') || 'Copied';
        var copyResetTimer;

        copyBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var code = copyBtn.getAttribute('data-discount-code');
          if (!code) return;

          navigator.clipboard.writeText(code).then(function () {
            if (labelEl) labelEl.textContent = copiedLabel;
            copyBtn.classList.add('promo-banner__discount-copy--copied');

            clearTimeout(copyResetTimer);
            copyResetTimer = setTimeout(function () {
              if (labelEl) labelEl.textContent = originalLabel;
              copyBtn.classList.remove('promo-banner__discount-copy--copied');
            }, 3000);
          });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoBanners);
  } else {
    initPromoBanners();
  }

  // Re-init when Shopify section is re-rendered
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initPromoBanners);
  }
})();
